import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col, Form, Container, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaSearch } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { serviceGetInforme, serviceGetSolicitudGestion } from '../../../../api/api-confirmar-cierre';
import { LoadingComponent } from 'recupero-comunes';

const HeaderInfo = ({ cfg_form, implicado, solicitud, setSolicitud }) => {
    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getSolicitudGestion()
    }, [])

    const getSolicitudGestion = async () => {
        let query = Buffer.from(JSON.stringify({ idCaso: llaves.idCaso, idImplicado: implicado, grupoSolGestion: 246002 })).toString('base64');
        const response = await serviceGetSolicitudGestion(query);

        setSolicitud(response && response.length > 0 ? response[0] : null);
    }

    const handleInforme = async () => {
        if (solicitud.folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: llaves.idCaso,
                idImplicadoCaso: implicado,
                idCompania: llaves.idOrgCaso,
                idfolioCarga: solicitud.folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />

            <Container className='mb-4'>
                <Row>
                    <Col md='3'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalconfirmarcierre-lbl-abogado"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>{solicitud?.usuarioSolDcto}</Form.Text>
                    </Col>
                    <Col md='3'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalconfirmarcierre-lbl-sitcierre"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>{solicitud?.motivoSolDcto}</Form.Text>
                    </Col>
                    <Col md='3'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalconfirmarcierre-lbl-fechinfo"]}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>{solicitud?.fecSolDctoFormat}</Form.Text>
                    </Col>
                    <Col md='1' style={{ width: '5%', marginTop: '10px' }}>
                        <OverlayTrigger overlay={<Tooltip id='tooltip-disabled'>{solicitud?.folioCarga ? "Ver Informe de Cierre" : "No existe Informe"}</Tooltip>}>
                            <Button className='' variant='info' disabled={!solicitud?.folioCarga}>
                                <FaSearch
                                    size={20}
                                    color='white'
                                    onClick={handleInforme}
                                />
                            </Button>
                        </OverlayTrigger>
                    </Col>
                    <Col md='2'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalconfirmarcierre-lbl-lupa"]}
                        </Form.Label>
                    </Col>

                    <Col md='12'>
                        <Form.Label className='mb-0 mt-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {cfg_form && cfg_form["modalconfirmarcierre-lbl-comentarioabo"]}
                        </Form.Label>
                        <Form.Control
                            readOnly
                            as="textarea"
                            rows={3}
                            className='mt-2'
                            name='comentario'
                            value={solicitud?.comentarioSolDcto}
                        />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default HeaderInfo;